import { render, staticRenderFns } from "./CourseWorkspace.vue?vue&type=template&id=3d040a22&scoped=true"
import script from "./CourseWorkspace.vue?vue&type=script&lang=ts"
export * from "./CourseWorkspace.vue?vue&type=script&lang=ts"
import style0 from "./CourseWorkspace.vue?vue&type=style&index=0&id=3d040a22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d040a22",
  null
  
)

export default component.exports